import type { Concept } from '@yuan-math/curriculum';
import { ELEMENTARY_CONCEPTS } from './elementary.ts';
import { GRADE_THREE_CONCEPTS } from './grade-three.ts';
import { GRADE_FOUR_CONCEPTS } from './grade-four.ts';
import { GRADE_FIVE_CONCEPTS } from './grade-five.ts';
import { MIDDLE_CONCEPTS } from './middle.ts';
import { UPPER_MIDDLE_CONCEPTS } from './middle-upper.ts';
import { GRADE_EIGHT_CONCEPTS } from './grade-eight.ts';
import { ALGEBRA_ONE_CONCEPTS } from './algebra-one.ts';
import { GEOMETRY_HS_CONCEPTS } from './geometry-hs.ts';
import { ALGEBRA_TWO_CONCEPTS } from './algebra-two.ts';
import { PRECALCULUS_CONCEPTS } from './precalculus.ts';
import { CALCULUS_CONCEPTS } from './calculus.ts';
import { CALCULUS_TWO_CONCEPTS } from './calculus-two.ts';
import { LINEAR_ALGEBRA_CONCEPTS } from './linear-algebra.ts';
import { STATISTICS_CONCEPTS } from './statistics.ts';
import { PLANNED_CONCEPTS } from './planned.ts';

export const CONCEPTS: Concept[] = [
  ...ELEMENTARY_CONCEPTS,
  ...GRADE_THREE_CONCEPTS,
  ...GRADE_FOUR_CONCEPTS,
  ...GRADE_FIVE_CONCEPTS,
  ...MIDDLE_CONCEPTS,
  ...UPPER_MIDDLE_CONCEPTS,
  ...GRADE_EIGHT_CONCEPTS,
  ...ALGEBRA_ONE_CONCEPTS,
  ...GEOMETRY_HS_CONCEPTS,
  ...ALGEBRA_TWO_CONCEPTS,
  ...PRECALCULUS_CONCEPTS,
  ...CALCULUS_CONCEPTS,
  ...CALCULUS_TWO_CONCEPTS,
  ...LINEAR_ALGEBRA_CONCEPTS,
  ...STATISTICS_CONCEPTS,
  ...PLANNED_CONCEPTS,
];
export {
  ELEMENTARY_CONCEPTS,
  GRADE_THREE_CONCEPTS,
  GRADE_FOUR_CONCEPTS,
  GRADE_FIVE_CONCEPTS,
  MIDDLE_CONCEPTS,
  UPPER_MIDDLE_CONCEPTS,
  GRADE_EIGHT_CONCEPTS,
  ALGEBRA_ONE_CONCEPTS,
  GEOMETRY_HS_CONCEPTS,
  ALGEBRA_TWO_CONCEPTS,
  PRECALCULUS_CONCEPTS,
  CALCULUS_CONCEPTS,
  CALCULUS_TWO_CONCEPTS,
  LINEAR_ALGEBRA_CONCEPTS,
  STATISTICS_CONCEPTS,
  PLANNED_CONCEPTS,
};
